<template>
  <span
    v-if="showLabel"
    class="sj-image-letter"
    v-bind="$attrs"
    :class="{ round }"
    :style="letterStyle"
  >
    {{ firstLetter }}
  </span>
  <img
    v-else
    class="sj-image"
    v-bind="$attrs"
    :class="{ round }"
    :style="imageStyle"
    :src="finalSrc"
    @error="handleError"
  />
</template>

<script>
/**
 * image组件，用于引用本地或远程图片，并在加载失败时进行fallback
 */
import { getDefaultProp } from "../../../utils";

export default {
  name: "SjImage",
  props: {
    // 远程图片
    src: String,
    // 本地图片
    localSrcPath: Promise,
    label: String,
    fontSize: {
      type: String,
      default: "14px"
    },
    round: {
      type: Boolean,
      default: false
    },
    imageStyle: {
      type: Object,
      default() {
        return {
          width: "100%",
          height: "100%"
        };
      }
    },
    defaultImage: {
      type: String,
      default: require("../../../../assets/image/defailtImg.png")
    },
    randomColors: {
      type: Array,
      default() {
        return ["#ff6d3f", "#3fb6e8", "#89af33", "#ffc12c"];
      }
    },
    cacheColor: {
      type: Boolean,
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.Image?.cacheColor,
          false
        );
      }
    }
  },
  data() {
    return {
      localSrc: null,
      isError: false
    };
  },
  computed: {
    /**
     * 结果src为加载完毕的localSrc或远程src
     * 失败时使用默认图片
     */
    finalSrc() {
      if (this.isError) return this.defaultImage;
      if (!this.localSrc && !this.src) return this.defaultImage;
      return this.localSrc || this.src;
    },
    firstLetter() {
      const { label } = this;
      if (!label) return null;
      return label.charAt(0).toUpperCase();
    },
    showLabel() {
      const { isError, localSrc, src, firstLetter } = this;
      return (isError || (!localSrc && !src)) && firstLetter;
    },
    letterStyle() {
      const { imageStyle } = this;
      return Object.assign(
        {},
        {
          backgroundColor: this.getRandomColor()
        },
        imageStyle
      );
    }
  },
  methods: {
    handleError(e) {
      console.log("handleerror", e);
      if (!this.isError) {
        this.isError = true;
      }
    },
    getRandomColor() {
      const { label, cacheColor } = this;
      if (cacheColor) {
        if (!window.sjImageLableColorMap) {
          window.sjImageLableColorMap = {};
        }
        const { sjImageLableColorMap } = window;
        if (sjImageLableColorMap[label]) {
          return sjImageLableColorMap[label];
        }
      }
      const { randomColors } = this;
      let color = "#ffc12c";
      if (randomColors && randomColors.length) {
        color = randomColors[Math.floor(Math.random() * randomColors.length)];
      }
      if (cacheColor) {
        Object.assign(window.sjImageLableColorMap, {
          [label]: color
        });
      }
      return color;
    }
  },
  watch: {
    /**
     * 加载本地import()导入的图片
     */
    localSrcPath: {
      immediate: true,
      async handler(localSrcPath) {
        this.isError = false;
        if (!localSrcPath) return;
        try {
          this.localSrc = (await localSrcPath).default;
        } catch (e) {
          this.handleError();
        }
      }
    },

    /**
     * 加载远程图片url
     */
    src: {
      immediate: true,
      async handler() {
        this.isError = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.sj-image-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  color: @color-antibg;
  &.round {
    border-radius: 50%;
  }
}

.sj-image {
  display: flex;
  overflow: hidden;
  &.round {
    border-radius: 50%;
  }
}
</style>
